import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { MessageCardComponent } from './message-card.component';
import { ButtonModule } from 'src/app/ui/button';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule
  ],
  declarations: [MessageCardComponent],
  exports: [MessageCardComponent]
})
export class MessageCardModule {
}
